import script from "./AccountCreds.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountCreds.vue?vue&type=script&setup=true&lang=js"

import "./AccountCreds.vue?vue&type=style&index=0&id=f13e2f36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f13e2f36"]])

export default __exports__